import { render } from "./TodoResetSwitch.vue?vue&type=template&id=5fcfe3b8"
import script from "./TodoResetSwitch.vue?vue&type=script&lang=js"
export * from "./TodoResetSwitch.vue?vue&type=script&lang=js"

import "./TodoResetSwitch.vue?vue&type=style&index=0&id=5fcfe3b8&lang=css"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\homepage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__